import {
  hideValidationPopup,
  showPopup,
  validationPopup,
} from "../redux/actions";
import { changePasswordPB } from "../auth/authApi";

export const validatePassword = (formData, lang = "en") => {
  const errors = {};
  const requiredMessage =
    lang === "en" ? "This field is required" : "この項目は必須です";
  const invalidPasswordMessage =
    lang === "en"
      ? "Password must be at least 6 characters"
      : "パスワードは6文字以上である必要があります";

  // Validate current password
  if (!formData.currentPassword?.trim()) {
    errors.currentPassword = requiredMessage;
  }

  // Validate new password
  if (!formData.newPassword?.trim()) {
    errors.newPassword = requiredMessage;
  } else if (formData.newPassword.length < 6) {
    errors.newPassword = invalidPasswordMessage;
  }

  // Check if passwords are same
  if (
    formData.currentPassword &&
    formData.newPassword &&
    formData.currentPassword === formData.newPassword
  ) {
    errors.newPassword =
      lang === "en"
        ? "New password must be different from current password"
        : "新しいパスワードは現在のパスワードと異なる必要があります";
  }

  return errors;
};

export const submitPasswordChange = async (dispatch, formData, lang = "en") => {
  const errors = validatePassword(formData, lang);
  if (Object.keys(errors).length > 0) {
    const errorMessage =
      Object.keys(errors).length > 1
        ? lang === "en"
          ? "Please complete all necessary fields."
          : "必須項目を入力してください。"
        : Object.values(errors)[0];

    dispatch(
      validationPopup({
        message: errorMessage,
        icon: "horror",
        type: "error",
      })
    );
    return { success: false, errors };
  }

  dispatch(
    validationPopup({
      message: "Loading...",
      icon: "loading_ani",
      type: "info",
    })
  );

  try {
    const updated = await changePasswordPB(
      formData.currentPassword,
      formData.newPassword
    );

    if (updated?.id) {
      dispatch(hideValidationPopup());
      dispatch(showPopup("settingPassword"));
      return { success: true };
    }
    // Fallback: unexpected shape
    dispatch(
      validationPopup({
        message:
          lang === "en"
            ? "Failed to update password"
            : "パスワードの更新に失敗しました",
        icon: "horror",
        type: "error",
      })
    );
    return {
      success: false,
      errors: {
        submit:
          lang === "en"
            ? "Failed to update password"
            : "パスワードの更新に失敗しました",
      },
    };
  } catch (error) {
    // Check for error message in response
    let errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      (lang === "en"
        ? "Failed to update password"
        : "パスワードの更新に失敗しました");

    // PocketBase ClientResponseError may include field-specific messages
    const fieldErrors = error?.data || error?.response?.data?.data;
    const detailed =
      fieldErrors?.oldPassword?.message || fieldErrors?.password?.message;
    if (detailed) errorMessage = detailed;

    dispatch(
      validationPopup({
        message: errorMessage,
        icon: "horror",
        type: "error",
      })
    );

    return { success: false, errors: { submit: errorMessage } };
  }
};
